import script from "./DatenschutzerklaerungView.vue?vue&type=script&setup=true&lang=js"
export * from "./DatenschutzerklaerungView.vue?vue&type=script&setup=true&lang=js"

import "./DatenschutzerklaerungView.vue?vue&type=style&index=0&id=5cb04b0f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5cb04b0f"]])

export default __exports__